import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const otherApi = createApi({
    reducerPath: 'otherApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_DATALYZE_SERVICE_BASE_URL,
    }),
    tagTypes: ['ContactUs'],
    endpoints: (builder) => ({
        //POST /contact-us
        contactUs: builder.mutation({
            query: (payload) => ({
                url: '/contact-us',
                method: 'POST',
                body: payload,
            })
        })
    })
});

export const {
    useContactUsMutation
} = otherApi;